export default {
    'grapesjs-object-fit': {
        'fill': 'Fill',
        'contain': 'Contain',
        'cover': 'Cover',
        'none': 'None',
        'scale-down': 'Scale Down',
    },
};
